import React from 'react';
import { FaApple } from 'react-icons/fa';
import { AiFillAndroid } from 'react-icons/ai';
import Header from './Components/Header';

function App() {
  return (
    <div className="container pb-12 mx-auto px-2">
      <Header />
      <div className="grid lg:gap-0 gap-16 lg:grid-cols-2 w-full items-center">
        <div className="">
          <h1 className="sm:text-5xl text-4xl font-bold">ShoeShop App</h1>
          <p className="sm:w-3/4 leading-8 my-8">
            ShoeShop is a mobile app that allows you to buy shoes from your
            mobile phone. ShoeShop it created using React Native,Native Base and
            Expo. Download Expo Go app in your mobile phone and scan the QR
            code. By Open the app you can see the list of shoes. You can add
            shoes to your cart and checkout.(Note: This is a frontend only)
            <br />
            <span className="mt-4 italic text-sm">
              Expo Go: Supported SDK (46, 47, 48,)
            </span>
          </p>
          {/* download button */}
          <div className="flex sm:flex-row flex-col gap-6">
            <a
              href="https://apps.apple.com/us/app/expo-go/id982107779"
              target="_blank"
              rel="noreferrer"
              className="bg-main hover:scale-105 transitions flex-rows gap-4 text-white py-3 px-8 rounded-md"
            >
              Expo Go <FaApple />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=host.exp.exponent"
              target="_blank"
              rel="noreferrer"
              className="border-main border-2  hover:scale-105 transitions flex-rows gap-4 text-black py-3 px-8 rounded-md"
            >
              Expo Go <AiFillAndroid />
            </a>
          </div>
        </div>
        <div className="p-6 h-96 sm:h-big rounded-lg border-2 border-main border-dashed bg-white">
          <img
            className="w-full h-full object-contain"
            src="/images/qr-shoeshop.png"
            alt="qr code"
          />
        </div>
      </div>
    </div>
  );
}

export default App;
